<template>
    <ModalBase :with-content="true" :fix-height="fixHeight" :theme="true" :max-width="maxWidth" :min-width="minWidth" @close="close">
        <loader :loading="true" v-if="loading"></loader>
        <main :class="{ overlay, fixWidth }" :style="mainStyle">
            <div class="overlay-container"><slot name="overlay"></slot></div>
            <slot name="main"></slot>
        </main>
        <footer><slot name="footer"></slot></footer>
    </ModalBase>
</template>

<script>
import ModalBase from "@/components/modal/ModalBase";
import loader from "@/components/loader/loader";

export default {
    name: "ModalTheme",
    components: { ModalBase, loader },
    props: {
        loading: {
            required: false,
            type: Boolean,
            default: false
        },
        overlay: {
            required: false,
            type: Boolean,
            default: false
        },
        fixHeight: {
            required: false,
            type: Boolean,
            default: true
        },
        fixWidth: {
            required: false,
            type: Boolean,
            default: true
        },
        autoWidth: {
            required: false,
            type: Boolean,
            default: false
        },
        maxWidth: {
            required: false,
            type: String,
            default: undefined
        },
        minWidth: {
            required: false,
            type: String,
            default: undefined
        }
    },
    computed: {
        mainStyle() {
            if (!this.autoWidth) return {};
            return {
                width: "80vw",
                height: "auto",
                maxHeight: "80vh",
                overflow: "auto"
            };
        }
    },
    methods: {
        close() {
            this.$emit("close");
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../assets/css/media";
@import "../../assets/css/themes";
main {
    @extend %primary-text;
    @extend %primary-background;
    @extend %primary-border-color;
    border-width: 1px;
    border-style: solid;
    padding: 4%;
    width: 100%;
    &.fixWidth {
        width: 650px;
    }
    height: calc(100% - 50px);
    overflow-y: auto;
    @include md {
        width: 500px;
    }
    @include sm {
        width: 350px;
    }
    &.overlay {
        padding: 0;
        overflow: hidden;
        position: relative;
        .overlay-container {
            position: sticky;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, 0.9);
            width: 100%;
            height: 100%;
            z-index: 1;
        }
    }
}
footer {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    > * {
        margin-left: 5px;
    }
}
</style>



// WEBPACK FOOTER //
// ModalTheme.vue?01beb1a5